var cov_1izwwf3si5 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Table/Expand.tsx",
      hash = "196dd65b9ee0e6dc420b24226a0bfbbb92ca5318",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Table/Expand.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 35
        },
        end: {
          line: 11,
          column: 1
        }
      },
      "1": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 16
        }
      },
      "2": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 50
        }
      },
      "3": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 48
        }
      },
      "4": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 46
        }
      },
      "5": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 20
        }
      },
      "6": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 33
        }
      },
      "7": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 35,
          column: 5
        }
      },
      "8": {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 34,
          column: 59
        }
      },
      "9": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 21
        }
      },
      "10": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 45,
          column: 5
        }
      },
      "11": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 44,
          column: 65
        }
      },
      "12": {
        start: {
          line: 49,
          column: 34
        },
        end: {
          line: 49,
          column: 44
        }
      },
      "13": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 57,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        loc: {
          start: {
            line: 16,
            column: 34
          },
          end: {
            line: 22,
            column: 3
          }
        },
        line: 16
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        },
        loc: {
          start: {
            line: 24,
            column: 22
          },
          end: {
            line: 26,
            column: 3
          }
        },
        line: 24
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 25
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 28
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        },
        loc: {
          start: {
            line: 32,
            column: 14
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 32
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        loc: {
          start: {
            line: 38,
            column: 39
          },
          end: {
            line: 40,
            column: 3
          }
        },
        line: 38
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        },
        loc: {
          start: {
            line: 42,
            column: 36
          },
          end: {
            line: 46,
            column: 3
          }
        },
        line: 42
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        },
        loc: {
          start: {
            line: 48,
            column: 11
          },
          end: {
            line: 58,
            column: 3
          }
        },
        line: 48
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 33,
            column: 4
          },
          end: {
            line: 35,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 33,
            column: 4
          },
          end: {
            line: 35,
            column: 5
          }
        }, {
          start: {
            line: 33,
            column: 4
          },
          end: {
            line: 35,
            column: 5
          }
        }],
        line: 33
      },
      "1": {
        loc: {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 45,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 45,
            column: 5
          }
        }, {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 45,
            column: 5
          }
        }],
        line: 43
      },
      "2": {
        loc: {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 43,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 43,
            column: 10
          }
        }, {
          start: {
            line: 43,
            column: 14
          },
          end: {
            line: 43,
            column: 30
          }
        }],
        line: 43
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Table/Expand.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { throttleWrapper } from '../utils/lazyload';
var iframeStyle = (cov_1izwwf3si5.s[0]++, {
  position: 'absolute',
  left: 0,
  width: 0,
  height: '100%',
  border: 0
});

var Expand =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Expand, _PureComponent);

  var _super = _createSuper2(Expand);

  function Expand(props) {
    var _this;

    _classCallCheck(this, Expand);

    cov_1izwwf3si5.f[0]++;
    cov_1izwwf3si5.s[1]++;
    _this = _super.call(this, props);
    _this.element = void 0;
    cov_1izwwf3si5.s[2]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    cov_1izwwf3si5.s[3]++;
    _this.bindIframe = _this.bindIframe.bind(_assertThisInitialized(_this));
    cov_1izwwf3si5.s[4]++;
    _this.setHeight = _this.setHeight.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Expand, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_1izwwf3si5.f[1]++;
      cov_1izwwf3si5.s[5]++;
      this.setHeight();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_1izwwf3si5.f[2]++;
      cov_1izwwf3si5.s[6]++;
      this.props.setExpandHeight(0);
    }
  }, {
    key: "setHeight",
    value: function setHeight() {
      cov_1izwwf3si5.f[3]++;
      cov_1izwwf3si5.s[7]++;

      if (this.element) {
        cov_1izwwf3si5.b[0][0]++;
        cov_1izwwf3si5.s[8]++;
        this.props.setExpandHeight(this.element.clientHeight);
      } else {
        cov_1izwwf3si5.b[0][1]++;
      }
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      cov_1izwwf3si5.f[4]++;
      cov_1izwwf3si5.s[9]++;
      this.element = el;
    }
  }, {
    key: "bindIframe",
    value: function bindIframe(el) {
      cov_1izwwf3si5.f[5]++;
      cov_1izwwf3si5.s[10]++;

      if ((cov_1izwwf3si5.b[2][0]++, el) && (cov_1izwwf3si5.b[2][1]++, el.contentWindow)) {
        cov_1izwwf3si5.b[1][0]++;
        cov_1izwwf3si5.s[11]++;
        el.contentWindow.onresize = throttleWrapper(this.setHeight);
      } else {
        cov_1izwwf3si5.b[1][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_1izwwf3si5.f[6]++;

      var _ref = (cov_1izwwf3si5.s[12]++, this.props),
          colSpan = _ref.colSpan,
          children = _ref.children;

      cov_1izwwf3si5.s[13]++;
      return (
        /*#__PURE__*/
        React.createElement("tr", {
          ref: this.bindElement,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 51,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("td", {
          style: {
            padding: 0
          },
          colSpan: colSpan,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 52,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement("iframe", {
          title: "scroll",
          ref: this.bindIframe,
          style: iframeStyle,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 53,
            columnNumber: 11
          }
        }), children))
      );
    }
  }]);

  return Expand;
}(PureComponent);

export default Expand;